export const BlogCardPlaceholder: React.FC = () => {
  return (
    <div className="cursor-disabled">
      <div className="h-56 w-full animate-pulse rounded-lg bg-black" />
      <div className="mt-6 h-8 w-full animate-pulse rounded-lg bg-black" />
      <div className="mt-4 h-4 w-2/3 animate-pulse rounded-lg bg-black" />
    </div>
  )
}
